import { WebglPipelineProgram } from "../../webgl-pipeline-program";
import fragmentShader from "./joint-bilateral.frag?raw";
import vertexShader from "./joint-bilateral.vert?raw";

export class JointBilateral extends WebglPipelineProgram {
    protected getFragmentShader(): string {
        return fragmentShader;
    }
    protected getVertexShader(): string {
        return vertexShader;
    }
}
